// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__2udKh","log":"ModalInventoryLogs_log__ZXo3c","date":"ModalInventoryLogs_date__17TiJ","userName":"ModalInventoryLogs_userName__14LZb"};